// extracted by mini-css-extract-plugin
module.exports = {"cardContent":"pH","checkbox":"pI","labelText":"pJ","warningMessage":"pK","optText":"pL"};